import { Component, Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-card-ccv-helper-dialog',
    template: require('./dialogCardCCVHelper.html'),
})
export class CardCcvHelperDialog {

    constructor(@Inject(MatDialogRef<CardCcvHelperDialog>) public dialogRef: MatDialogRef<CardCcvHelperDialog>) {
    }

    closeDialog(value: any) {
        this.dialogRef.close(value)
    }

}
